import { ErrorWithFields as o } from "./index6.mjs";
import { ErrorWithViolations as e } from "./index7.mjs";
class d extends o {
  toErrorWithViolations() {
    return super.toErrorWithViolations({
      type: "",
      status: r.code,
      title: "",
      code: r.code
    });
  }
}
const t = class t extends e {
};
t.code = 422;
let r = t;
export {
  d as BadRequest,
  r as BadRequestWithViolations
};
